// extracted by mini-css-extract-plugin
export default {"moveStatus":"MoveStatus_moveStatus__YhyLE","cancelButton":"MoveStatus_cancelButton__rJ2Pp"};